import React, { useState, useEffect } from "react";
import { getDoc, doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase-config/firebase";
import { useParams } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);


const CreateMeds = () => {
    const [nombre, setNombre] = useState('')
    const [apellidos, setApellidos] = useState('')
    const [medicamento, setMedicamento] = useState('')
    const [dosis, setDosis] = useState('')
    const [horario, setHorario] = useState('')
    const { id } = useParams()
    const navigate = useNavigate()

    const getAdultoById = async (id) => {

        const adulto = await getDoc(doc(db, "adultosm", id))
        setApellidos(adulto.data().apellidos)
        setNombre(adulto.data().nombre) 
        
    }

    const storeMeds = async (e) => {
        e.preventDefault()
        const adultodoc = doc(db, "adultosm", id)
        const adulto = await getDoc(adultodoc)
        const datos = adulto.data()
        if (datos.recetas === undefined) {
          datos.recetas  = []
        }
        datos.recetas.push({
            dosis: dosis,
            horario: horario,
            medicamento: medicamento,
            
        })
        const data = {
          recetas: datos.recetas
        }
        MySwal.fire({     
            icon: "success",
            title: "Receta Agregada!",
            showConfirmButton: false,
            timer: 1500
          });
        await updateDoc(adultodoc, data)
        navigate(`/home/showAdult/${id}`)
      }
    useEffect(() => {
        getAdultoById(id)
        //eslint-disable-next-line
    }, [])

    return (
        <div className="container">

            <div className='Header'>
                <div className="row"> <h1>Ingresar un medicamento</h1> 
                </div>
                <div className='underlineC'></div>
            </div>

            <div className="row">

                <div className="col">

                    <div className="row">
                        <input disabled className="cornerSearch" value={nombre + " " + apellidos} type="text"></input>
                    </div>

                    <section className='container my-2 bg-dark w-adapt text-light p-2 rcorners'>

                        <form onSubmit={storeMeds} className='p-4 row g-2 formShadow'>

                            <div className='mb-3'>
                                <label className='form-label'>Nombre del Medicamento</label>
                                <input
                                    value={medicamento}
                                    onChange={(e) => setMedicamento(e.target.value)}
                                    type="text"
                                    className='form-control'
                                />
                            </div>

                            <div className='mb-3'>
                                <label className='form-label'>Dosis</label>
                                <input
                                    value={dosis}
                                    onChange={(e) => setDosis(e.target.value)}
                                    type="text"
                                    className='form-control'

                                />
                            </div>

                            <div className='mb-3'>
                                <label className='form-label'>Horario</label>
                                <input
                                    value={horario}
                                    onChange={(e) => setHorario(e.target.value)}
                                    type="text"
                                    className='form-control'
                                />
                            </div>

                            <button type='submit' className='submit'>Ingresar</button>
                        </form>
                    </section>
                </div>
            </div>
        </div>

    )

}
export default CreateMeds